
import React from 'react';
import { TrackDownload } from '@/lib/types';
import DataStatusIndicator from './DataStatusIndicator';
import DataControls from './DataControls';
import StatsSummary from './stats/StatsSummary';
import DownloadsChart from './stats/DownloadsChart';
import TopTracksTable from './stats/TopTracksTable';

interface DashboardStatsProps {
  filteredUploads: TrackDownload[];
  timeRange: string;
  setTimeRange: (range: string) => void;
  timeRanges: Record<string, { label: string; days: number }>;
  useMockData: boolean;
  handleRefresh: () => void;
  isRefreshing: boolean;
}

const DashboardStats: React.FC<DashboardStatsProps> = ({
  filteredUploads,
  timeRange,
  setTimeRange,
  timeRanges,
  useMockData,
  handleRefresh,
  isRefreshing
}) => {
  return (
    <div className="space-y-8 mb-8">
      {useMockData && <DataStatusIndicator useMockData={useMockData} />}
      
      <DataControls
        timeRange={timeRange}
        setTimeRange={setTimeRange}
        timeRanges={timeRanges}
        useMockData={useMockData}
        handleRefresh={handleRefresh}
        isRefreshing={isRefreshing}
      />
      
      <StatsSummary uploads={filteredUploads} timeRange={timeRange} />
      
      <div className="space-y-8">
        <DownloadsChart 
          uploads={filteredUploads} 
          timeRange={timeRange} 
          useMockData={useMockData}
        />
        
        <TopTracksTable uploads={filteredUploads} />
      </div>
    </div>
  );
};

export default DashboardStats;
